import { useState,useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Box, Card, Chip, Divider, FormControlLabel, Grid, Typography } from '@mui/material';
import { ButtonBasic } from '../../components';
import DialogTitleDefault from '../default/DialogTitleDefault';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const ModalNotifyFilter = ({show, hideModal, filtro, setFiltro}) => {
    const handleClose = () => hideModal();
    const [newFiltro, setNewFiltro] = useState(filtro);
    
    const onClickFilter = (nombreKey) => {
        setNewFiltro({
            ...newFiltro,
            [nombreKey]: !newFiltro[nombreKey]
        })
    }
    
    const onSubmit = () => {
        setFiltro(newFiltro)
        handleClose()
    }

    const filterOptions = [
        {
            key: 'ticket',
            label: 'Notificaciones de Tickets',
            icon: <ConfirmationNumberIcon sx={{ fontSize: 20 }} />,
            color: '#0364FF'
        },
        {
            key: 'etiquetas',
            label: 'Menciones y Etiquetas',
            icon: <LocalOfferIcon sx={{ fontSize: 20 }} />,
            color: '#10b981'
        },
        {
            key: 'gral',
            label: 'Notificaciones Generales',
            icon: <NotificationsIcon sx={{ fontSize: 20 }} />,
            color: '#f59e0b'
        },
        {
            key: 'soloNoVistas',
            label: 'Solo mostrar no vistas',
            icon: <VisibilityOffIcon sx={{ fontSize: 20 }} />,
            color: '#ef4444'
        }
    ];

    return(
        <Dialog 
            open={show} 
            disableEscapeKeyDown 
            maxWidth='sm' 
            fullWidth 
            sx={{
                backdropFilter: 'blur(1px)',
                '& .MuiDialog-paper': {
                    borderRadius: 2,
                    background: '#ffffff !important'
                }
            }}
        >
            <Box>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography 
                        sx={{ 
                            textAlign: 'center',
                            color: '#2d3748', 
                            fontWeight: 600, 
                            fontSize: 18
                        }} 
                        variant='h6'
                    >
                        Filtros de Notificaciones
                    </Typography>
                </DialogTitleDefault>
                
                <DialogContent sx={{ p: 2 }}>
                    <Grid container spacing={1.5}>
                        {filterOptions.map((option) => (
                            <Grid item xs={12} key={option.key}>
                                <Card
                                    onClick={() => onClickFilter(option.key)}
                                    sx={{
                                        p: 2,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        background: newFiltro[option.key] ? '#f0f8ff !important' : '#ffffff !important',
                                        border: newFiltro[option.key] 
                                            ? `2px solid ${option.color}` 
                                            : '1px solid #e3e7ed',
                                        borderRadius: 2,
                                        '&:hover': {
                                            background: '#f8f9fa',
                                            transform: 'translateY(-1px)',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                                        }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Box sx={{ color: newFiltro[option.key] ? option.color : '#a0aec0' }}>
                                            {option.icon}
                                        </Box>
                                        
                                        <Typography 
                                            sx={{ 
                                                color: newFiltro[option.key] ? option.color : '#2d3748',
                                                fontWeight: newFiltro[option.key] ? 600 : 500,
                                                fontSize: 14,
                                                flex: 1
                                            }}
                                        >
                                            {option.label}
                                        </Typography>
                                        
                                        {newFiltro[option.key] && (
                                            <Chip 
                                                label="Activo"
                                                size="small"
                                                sx={{
                                                    height: 24,
                                                    fontSize: 11,
                                                    fontWeight: 600,
                                                    backgroundColor: `${option.color}20`,
                                                    color: option.color
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                
                <Divider />
                
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={() => handleClose()}
                    />
                    <ButtonBasic
                        textButton='Aplicar'
                        onClick={() => onSubmit()}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalNotifyFilter